// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"169":"5f4fd151","619":"3b079773"}[chunkId] + ".css";
};